var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"icon-wrapper__content",attrs:{"tabindex":"-1"}},[_vm._t("default")],2),_c('div',{staticClass:"icon-wrapper__icon",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('click:icon')}}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }